module.exports = __webpack_public_path__ + "img/p-single-9.7deb0794.jpg";